 

<div style="display:flex; flex-wrap:wrap;">
	<div style="margin-bottom:10px;">Налаштувати дату і час</div>
	 <div style="display:flex; margin-left:auto;">

		<div  *ngIf="stream.show_date"></div>

		<p style=" position:relative;padding-left: 23px">
			<nb-icon  style="color: #929292;  position:relative; left:-2px; top:2px;" [icon]="'clock-outline'" pack="eva"></nb-icon>
			<a  (click)="openDateModal(dateModal)" href="javascript:;">Дата і час</a>  
		</p>


	 </div> 
   
</div>

<div  *ngIf="stream.show_date" class="text-right" > 
<span  >Дата: <b #dateTimeString >{{stream.show_date | date : 'dd.MM.yyyy,  HH:mm'}}</b></span>
<span style="cursor:pointer; margin-left:15px;" (click)="updateShowDate(0)" class="text-danger">Скинути</span>
 </div>





  <ng-template #dateModal  let-data   let-ref="dialogRef">

    <div style="max-width:500px">
           <nb-card>
        <nb-card-header>
    
      
      <div style="display:flex; width:100%">
        <span>Дата початку трансляції</span>   
         <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="ref.close()">
<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
	</span>  
      </div>
    </nb-card-header>
        <nb-card-body>
      <div>
          <div>
            <div>  <label>Дата:</label> </div>
            
            <input nbInput class="DateInput"   #dateInput [(ngModel)]="dateAndTime.date" placeholder="__.__.____"  [nbDatepicker]="datepicker">
            <nb-datepicker     #datepicker></nb-datepicker>
        </div>
         <div style="margin-top: 10px;">
            <div>  <label>Час:</label>  </div>
        <input nbInput  #timeInput [(ngModel)]="dateAndTime.time"   mask="Hh:m0" [showMaskTyped]="true" placeholder="__:__" >
        </div>
      </div>
    </nb-card-body>
        <nb-card-footer>
         
           
      <div style="display:flex; width:100%">

        <button style="display:flex; margin-left:15px; cursor: pointer;" (click)="saveDateTime(ref,dateInput, timeInput )" nbButton status="success" >Зберегти</button>

               <button style="display:flex; margin-left:15px; cursor: pointer;" (click)="ref.close()" nbButton status="basic" >Скасувати</button>
  
    
            </div>
        </nb-card-footer>
      </nb-card>
       
    </div>
      </ng-template>
